import { useTranslation } from "react-i18next";
import { Modal } from "@/shared/components/ui/Modal";
import { formatDateTime } from "@/shared/utils/formatters";

export interface Viewer {
  name: string;
  company?: string;
  seen_at?: string;
}

interface ViewersModalProps {
  isOpen: boolean;
  onClose: () => void;
  viewers: Viewer[];
}

export const ViewersModal = ({
  isOpen,
  onClose,
  viewers,
}: ViewersModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={`${t("feed.seen_by")} (${viewers.length})`}
      size="lg"
    >
      {viewers.length === 0 ? (
        <p className="text-sm text-gray-400 italic text-center py-6">
          {t("feed.no_viewers")}
        </p>
      ) : (
        <div className="overflow-x-auto -mx-4 px-4">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-xs text-gray-500 border-b border-gray-200">
                <th className="pb-2 font-medium">{t("feed.viewer_name")}</th>
                <th className="pb-2 font-medium">{t("feed.viewer_company")}</th>
                <th className="pb-2 font-medium">
                  {t("feed.viewer_datetime")}
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {viewers.map((v, i) => (
                <tr key={i} className="text-gray-700">
                  <td className="py-2 pr-3">{v.name}</td>
                  <td className="py-2 pr-3 text-gray-500 whitespace-nowrap">
                    {v.company || "—"}
                  </td>
                  <td className="py-2 text-gray-400 text-xs whitespace-nowrap">
                    {v.seen_at ? formatDateTime(v.seen_at) : "—"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Modal>
  );
};
